module.exports = new __parcel__URL__("shop_animated_3299_image.0bdd410a.png").toString();